'use client'

import { Button } from '@mentora/ui-components'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { authClient } from '@/lib/auth-client'

/**
 * The landing hero's sign-up CTA, gated client-side. Keeping the "is the user
 * logged in?" read out of the page's server render is what lets the landing
 * page stay static/ISR-cacheable (§11) instead of going dynamic for one cookie
 * read. Logged-out visitors (the common case) see the CTA immediately; it's
 * hidden only once the client confirms an active session.
 */
export function LandingCta() {
  const { data: session } = authClient.useSession()
  const t = useTranslations('landing')
  if (session?.user)
    return null

  return (
    <div
      className="animate-fade-up mt-10 flex flex-col items-center gap-4 sm:flex-row"
      style={{ animationDelay: '0.5s' }}
    >
      <Button asChild size="lg" className="relative overflow-hidden">
        <Link href="/sign-up">
          <span className="relative z-10">{t('getStarted')}</span>
        </Link>
      </Button>
    </div>
  )
}
